var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { padding: "20px", position: "relative" } },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: {
            "label-width": "210px",
            rules: _vm.rules,
            model: _vm.ruleForm,
            "label-position": "left"
          }
        },
        [
          _c("div", { staticClass: "border-bo" }, [_vm._v("风机排布 ")]),
          _c("div", { staticStyle: { width: "100%", height: "20px" } }),
          _c(
            "el-form-item",
            { attrs: { label: "陆上风场平均风速大于(m/s)", prop: "wspd" } },
            [
              _c("el-input", {
                attrs: {
                  maxlength: 10,
                  oninput: "value=value.replace(/[^\\d.]/g,'')"
                },
                model: {
                  value: _vm.ruleForm.wspd,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "wspd", $$v)
                  },
                  expression: "ruleForm.wspd"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: "风机间距长轴大于(D)", prop: "longAxisDistance" }
            },
            [
              _c("el-input", {
                attrs: { maxlength: 10 },
                model: {
                  value: _vm.ruleForm.longAxisDistance,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "longAxisDistance", $$v)
                  },
                  expression: "ruleForm.longAxisDistance"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: "风机间距短轴大于(D)", prop: "shortAxisDistance" }
            },
            [
              _c("el-input", {
                attrs: { maxlength: 10 },
                model: {
                  value: _vm.ruleForm.shortAxisDistance,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "shortAxisDistance", $$v)
                  },
                  expression: "ruleForm.shortAxisDistance"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "地形坡度小于(%)", prop: "maxSlope" } },
            [
              _c("el-input", {
                attrs: { maxlength: 10 },
                model: {
                  value: _vm.ruleForm.maxSlope,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "maxSlope", $$v)
                  },
                  expression: "ruleForm.maxSlope"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "距边界距离大于(m)", prop: "boundaryDistance" } },
            [
              _c("el-input", {
                attrs: { maxlength: 10 },
                model: {
                  value: _vm.ruleForm.boundaryDistance,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "boundaryDistance", $$v)
                  },
                  expression: "ruleForm.boundaryDistance"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "海上风场平均风速大于(m/s)", prop: "wspdSea" } },
            [
              _c("el-input", {
                attrs: { maxlength: 10 },
                model: {
                  value: _vm.ruleForm.wspdSea,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "wspdSea", $$v)
                  },
                  expression: "ruleForm.wspdSea"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "地形海拔小于(m)", prop: "defaultMaxAltitude" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.ruleForm.defaultMaxAltitude,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "defaultMaxAltitude", $$v)
                  },
                  expression: "ruleForm.defaultMaxAltitude"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "border-bo" }, [_vm._v("测风塔选址")]),
          _c("div", { staticStyle: { width: "100%", height: "20px" } }),
          _c(
            "el-form-item",
            { attrs: { label: "代表半径大于(m)", prop: "typicalRadius" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.ruleForm.typicalRadius,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "typicalRadius", $$v)
                  },
                  expression: "ruleForm.typicalRadius"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "地形坡度小于(%)", prop: "inflowAngle" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.ruleForm.inflowAngle,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "inflowAngle", $$v)
                  },
                  expression: "ruleForm.inflowAngle"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "距边界距离大于(m)", prop: "distance" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.ruleForm.distance,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "distance", $$v)
                  },
                  expression: "ruleForm.distance"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "border-bo" }, [_vm._v("发电量计算 ")]),
          _c("div", { staticStyle: { width: "100%", height: "20px" } }),
          _c(
            "el-form-item",
            { attrs: { label: "综合折减(%)", prop: "synthesizeLoss" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.ruleForm.synthesizeLoss,
                  callback: function($$v) {
                    _vm.$set(_vm.ruleForm, "synthesizeLoss", $$v)
                  },
                  expression: "ruleForm.synthesizeLoss"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-button",
        { attrs: { type: "primary", id: "baocun" }, on: { click: _vm.save } },
        [_vm._v("保存")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }